import { render, staticRenderFns } from "./biBasic.vue?vue&type=template&id=1145d3cc&scoped=true&"
import script from "./biBasic.vue?vue&type=script&lang=js&"
export * from "./biBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1145d3cc",
  null
  
)

export default component.exports